<template>
  <div>
    <Head title="Decline Reasons" />
    <h1 class="mb-8 text-3xl font-bold">Decline Reasons</h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block text-gray-700">Role:</label>
        <select class="form-select mt-1 w-full">
          <option :value="null" />
          <option />
        </select>
      </search-filter>
      <a
        v-if="user.group_permissions.includes('create_payment_requisition')
          || user.per_user_permissions.includes('create_payment_requisition')" class="btn-orange" href="#" @click="openCreateNewDRWindow"
      >
        <span>Create</span>
        <span class="hidden md:inline">&nbsp;New</span>
      </a>
    </div>
    <hr />
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-3 pt-3 px-2">Reason</th>
          <th class="pb-3 pt-3 px-2" />
        </tr>
        <tr v-for="pr in decline_reasons.data" :key="pr.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="flex items-center px-2 py-2 focus:text-indigo-500" :href="`#/decline_reasons/${pr.id}/payment-request-details`">
              {{ pr.name }}
            </Link>
          </td>
          <td class="w-px border-t">
            <Link class="flex items-center px-4" :href="`#/payment-request/${pr.id}/payment-request-details`" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
        </tr>
        <tr v-if="decline_reasons.data.length === 0">
          <td class="px-3 py-3 border-t" colspan="8">No data found</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="decline_reasons.links" />
  </div>
  <div v-if="isCreateDROpen" class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1 style="font-size: 24px;">New Decline Reason</h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              You are about to create new Payment Request, do you wish to continue?
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5" @click="openCreateNewPrWindow">
                Yes
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5" @click="closeOpenPR">
                No
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="isCreateDRWindowOpen" class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div class="inline-block align-bottom bg-white rounded-lg text-left w-1/2 overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1 style="font-size: 24px;">New Decline Reason</h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="flex flex-wrap -mb-8 -mr-6 p-8">
              <text-input v-model="formData.reason" class="pb-8 pr-6 w-full lg:w-full" label="Decline Reason" />
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button
                v-if="user.group_permissions.includes('create_payment_requisition')
                  || user.per_user_permissions.includes('create_payment_requisition')
                  || user.per_user_permissions.includes('create_global_payment_requisition')"
                type="button" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5" @click="submitNewDR"
              >
                Save
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5" @click="closeOpenDR">
                Cancel
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
    
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import Pagination from '@/Shared/Pagination'
import TextInput from '@/Shared/TextInput'
    
export default {
  components: {
    Head,
    Icon,
    Link,
    SearchFilter,
    Pagination,
    TextInput,
  },
  layout: Layout,
  props: {
    filters: Object,
    decline_reasons: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
      },
      isCreateDROpen: false,
      isCreateDRWindowOpen: false,
      formData: {
        'reason': null,
      },
    }
  },
  computed: {
    user() {
      return this.$inertia.page.props.auth.user
    },
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/decline_reasons', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    openCreateNewDR() {
      this.isCreateDROpen = true
    },
    closeOpenPR() {
      this.isCreatePrOpen = false
      this.isCreateDRWindowOpen = false
    },
    openCreateNewDRWindow() {
      this.isCreateDRWindowOpen = true
    },
    submitNewDR() {
      this.formData._method = 'post'
      this.$inertia.post('/decline-reasons', this.formData, {
        onSuccess: () => {
          this.isCreateDROpen = false
          this.$router.push('/decline-reasons')
        },
      })
    },
  },
}
</script>
    